import { Reveal } from "@/components/Reveal";
import { Sun, Users, Clock, Car, ShieldCheck, Sparkles } from "lucide-react";

const ITEMS = [
  { icon: Sparkles, title: "Doğal poz yönlendirmesi", desc: "Poz öğretmiyoruz; sizi rahatlatıyor, en doğal halinizi kadraja alıyoruz." },
  { icon: Sun, title: "Doğru ışık & saat planlaması", desc: "Gün batımı ve altın saat; her mekânı en güzel ışıkta çekiyoruz." },
  { icon: Car, title: "Tüm ilçelere ulaşım", desc: "Çankaya'dan Beypazarı'na, Ankara'nın her ilçesine geliyoruz." },
  { icon: Clock, title: "7 günde dijital teslim", desc: "Aylarca beklemek yok; kareleriniz 7 gün içinde link ile elinizde." },
  { icon: Users, title: "Deneyimli ekip", desc: "Fotoğraf ve video ekibi uyum içinde; bütünlüklü bir sonuç alırsınız." },
  { icon: ShieldCheck, title: "Net sözleşme & güvence", desc: "Paket içeriği ve teslim süresi baştan net; sürpriz maliyet yok." },
];

export const WhyUs = () => (
  <section className="section-pad bg-[#141517]">
    <div className="container-lux">
      <Reveal>
        <div className="max-w-2xl">
          <span className="eyebrow">Neden Biz</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
            Kalabalık yok. Işık sürprizi yok.
          </h2>
          <p className="text-[#9A9387] mt-4">
            Her sahne, fotoğrafın gerçek öznesi siz olacak şekilde planlanır. Hava durumuna ya da günün
            saatine bağlı kalmadan hayal ettiğiniz kareyi alırsınız.
          </p>
        </div>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-12">
        {ITEMS.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.06}>
            <div className="h-full rounded-2xl border border-white/10 bg-[#1A1B1E] p-6">
              <it.icon className="w-7 h-7 text-[#D7B86A]" />
              <h3 className="font-display text-xl text-[#F7F2E8] mt-4">{it.title}</h3>
              <p className="text-sm text-[#9A9387] mt-2 leading-relaxed">{it.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
